import React, { useState } from 'react';

import { TextField, Chip, Autocomplete } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const StyledAutocomplete = styled(Autocomplete)({
    '& .MuiAutocomplete-inputRoot': {
        flexWrap: 'wrap',
        gap: '8px',
        padding: '8px',
    },
    '& .MuiChip-root': {
        margin: '2px',
    },
});

const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim().toLowerCase());

const EmailAutocomplete = ({ control, name, defaultValue }) => {
    const [inputValue, setInputValue] = useState('');
    const [localError, setLocalError] = useState('');

    const handleInputChange = (event, newInputValue, reason) => {
        if (reason !== 'reset') {
            setInputValue(newInputValue);
        }
    };

    const handleAddEmail = (event, field) => {
        if (['Enter', ','].includes(event.key) && inputValue.trim()) {
            event.preventDefault();
            const newEmail = inputValue.trim().replace(',', '').toLowerCase();
            const currentEmails = field.value || [];

            if (!isValidEmail(newEmail)) {
                setLocalError('Formato de correo inválido');
                return;
            }

            if (currentEmails.includes(newEmail)) {
                setLocalError('Este correo ya fue ingresado');
                return;
            }

            setLocalError('');
            field.onChange([...currentEmails, newEmail]);
            setInputValue('');
        }
    };

    const handleDeleteEmail = (emailToDelete, field) => {
        const updated = field.value.filter((email) => email !== emailToDelete);
        field.onChange(updated);
    };

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || []}
            render={({ field }) => (
                <StyledAutocomplete
                    multiple
                    freeSolo
                    value={field.value}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    onChange={() => {}}
                    options={[]}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Correos electrónicos"
                            placeholder="Ingresa un correo y presiona Enter o coma"
                            error={!!localError}
                            helperText={localError}
                            onKeyDown={(event) => handleAddEmail(event, field)}
                        />
                    )}
                    renderTags={(value) =>
                        value.map((option, index) => (
                            <Chip
                                key={`${option}-${index}`}
                                label={option}
                                onDelete={() =>
                                    handleDeleteEmail(option, field)
                                }
                            />
                        ))
                    }
                />
            )}
        />
    );
};

EmailAutocomplete.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.arrayOf(PropTypes.string),
};

export default EmailAutocomplete;
